// Troncales DE UN CLIENTE — se monta dentro de su ficha (ClientesV2 → pestaña Líneas).
//
// La configuración de la troncal es una propiedad del cliente, no una sección aparte: por eso
// vive acá y no en una pantalla propia con selector de cliente (ese fue el diseño inicial y
// estaba mal: obligaba a salir del cliente para configurarle su servicio).
//
// Ver docs/DISENO_troncal_ip.md. El SBC no interviene: el cliente apunta directo al SS.
import { useState, useEffect, useCallback } from "react";
import { PermisosDeUnaTroncal } from "./PermisosTroncal";
import apiv1 from "../api_v1";
import { useConfirm } from "./ConfirmDialog";

const safe = async (fn) => { try { return await fn(); } catch { return null; } };

const Chip = ({ bg, bd, fg, children, title }) => (
  <span title={title} style={{ display:"inline-flex", alignItems:"center", gap:5, fontSize:10.5,
    fontWeight:600, padding:"2.5px 8px", borderRadius:999, background:bg,
    border:`1px solid ${bd}`, color:fg, whiteSpace:"nowrap" }}>{children}</span>
);
const ChipOk    = (p) => <Chip bg="var(--success-bg)" bd="var(--success)" fg="var(--success)" {...p}/>;
const ChipWarn  = (p) => <Chip bg="var(--warning-bg)" bd="var(--warning)" fg="var(--warning)" {...p}/>;
const ChipBrand = (p) => <Chip bg="var(--brand-subtle)" bd="var(--border-active)" fg="var(--brand)" {...p}/>;
const ChipMuted = (p) => <Chip bg="var(--bg-raised)" bd="var(--border)" fg="var(--text-muted)" {...p}/>;

const inp = { padding:"7px 9px", borderRadius:"var(--r-sm)", border:"1px solid var(--border)",
              background:"var(--bg-raised)", color:"var(--text-primary)", fontSize:12.5, width:"100%" };
const lbl = { display:"flex", flexDirection:"column", gap:5, fontSize:11, color:"var(--text-secondary)" };
const mono = { fontFamily:"var(--font-mono)", fontVariantNumeric:"tabular-nums" };

/* ── Alta de troncal ── */
function ModalNueva({ cliente, onClose, onSaved }) {
  const [f, setF] = useState({ nombre:"", origin_ip:"", origin_port:5060, cantidad_dids:30,
                               max_channels_por_did:5, cli_policy:"strict", rotativo:true });
  const [bloque, setBloque] = useState(null);
  const [cargandoBloque, setCB] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr]   = useState(null);
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));

  // El bloque se propone según la provincia del cliente: un número solo es único
  // como (código de área, local), así que la búsqueda va acotada a su área.
  useEffect(() => {
    let vivo = true;
    (async () => {
      setCB(true);
      const r = await safe(() => apiv1.get(
        `/numeracion/bloque?client_id=${cliente.id}&cantidad=${f.cantidad_dids}`));
      if (vivo) { setBloque(r?.data || null); setCB(false); }
    })();
    return () => { vivo = false; };
  }, [cliente.id, f.cantidad_dids]);

  const crear = async () => {
    setBusy(true); setErr(null);
    try {
      const r = await apiv1.post("/troncales", { client_id: cliente.id, ...f });
      onSaved(r.data);
    } catch (e) {
      setErr(e.response?.data?.detail || "No se pudo crear la troncal");
    } finally { setBusy(false); }
  };

  const b = bloque?.bloque;
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(4,8,16,.7)",
      display:"grid", placeItems:"center", zIndex:300, padding:16, overflowY:"auto" }}>
      <div onClick={e => e.stopPropagation()} className="nv-card"
        style={{ width:"min(620px,100%)", padding:0, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:"1px solid var(--border)" }}>
          <div style={{ fontSize:14, fontWeight:600 }}>Nueva troncal</div>
          <div style={{ fontSize:11.5, color:"var(--text-secondary)", marginTop:2 }}>
            {cliente.name} · {cliente.provincia || "sin provincia"}
          </div>
        </div>
        <div style={{ padding:18, display:"flex", flexDirection:"column", gap:14 }}>

          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:14 }}>
            <label style={lbl}>Nombre de la troncal
              <input style={inp} value={f.nombre} placeholder="Central Guayaquil"
                onChange={e => set("nombre", e.target.value)}/>
            </label>
            <label style={lbl}>IP de origen
              <input style={{ ...inp, ...mono }} value={f.origin_ip} placeholder="190.152.44.18"
                onChange={e => set("origin_ip", e.target.value.trim())}/>
            </label>
            <label style={lbl}>Puerto
              <input style={{ ...inp, ...mono }} value={f.origin_port} type="number"
                onChange={e => set("origin_port", e.target.value)}/>
            </label>
          </div>

          <div>
            <div style={{ fontSize:11, color:"var(--text-secondary)", marginBottom:6 }}>
              Numeración — bloque consecutivo libre
            </div>
            {cargandoBloque ? (
              <div style={{ padding:14, background:"var(--bg-raised)", borderRadius:"var(--r-sm)",
                fontSize:12, color:"var(--text-secondary)" }}>Buscando bloque…</div>
            ) : b ? (
              <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap",
                background:"var(--bg-raised)", border:"1px solid var(--border-active)",
                borderRadius:"var(--r-md)", padding:"13px 15px" }}>
                <span style={{ ...mono, fontSize:16, fontWeight:600 }}>{b.did_desde}</span>
                <span style={{ color:"var(--brand)" }}>→</span>
                <span style={{ ...mono, fontSize:16, fontWeight:600 }}>{b.did_hasta}</span>
                <span style={{ marginLeft:"auto" }}>
                  <ChipOk>{f.cantidad_dids} consecutivos</ChipOk>
                </span>
              </div>
            ) : (
              // Decisión de producto: el alta NO se traba. Queda "falta configurar".
              <div style={{ border:"1px dashed var(--warning)", background:"var(--warning-bg)",
                borderRadius:"var(--r-md)", padding:15, display:"flex", flexDirection:"column", gap:7 }}>
                <ChipWarn>Falta configurar</ChipWarn>
                <div style={{ fontSize:12.5, color:"var(--text-primary)", fontWeight:600 }}>
                  {bloque?.motivo || "No hay numeración disponible"}
                </div>
                <div style={{ fontSize:11.5, color:"var(--text-secondary)", maxWidth:"64ch" }}>
                  La troncal se puede crear igual y asignarle la numeración después. Queda sin
                  DIDs hasta entonces, así que no cursará llamadas entrantes.
                </div>
              </div>
            )}
          </div>

          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:14 }}>
            <label style={lbl}>Cantidad de DIDs
              <input style={{ ...inp, ...mono }} type="number" min="1" max="1000" value={f.cantidad_dids}
                onChange={e => set("cantidad_dids", parseInt(e.target.value, 10) || 1)}/>
            </label>
            <label style={lbl}>Llamadas por DID
              <input style={{ ...inp, ...mono }} type="number" min="1" max="1000"
                value={f.max_channels_por_did}
                onChange={e => set("max_channels_por_did", parseInt(e.target.value, 10) || 1)}/>
            </label>
            <label style={lbl}>Si el ANI no es de la troncal
              <select style={inp} value={f.cli_policy} onChange={e => set("cli_policy", e.target.value)}>
                <option value="strict">Rechazar la llamada</option>
                <option value="default_on_mismatch">Sustituir por el DID principal</option>
                <option value="allow_any">Permitir cualquiera</option>
              </select>
            </label>
          </div>

          <label style={{ display:"flex", alignItems:"center", gap:9, fontSize:12.5,
            color:"var(--text-primary)", cursor:"pointer" }}>
            <input type="checkbox" checked={f.rotativo}
              onChange={e => set("rotativo", e.target.checked)}/>
            Rotativo — si el DID está ocupado, la entrante pasa al siguiente libre del bloque
          </label>

          <div style={{ fontSize:11.5, color:"var(--text-secondary)", background:"var(--brand-subtle)",
            borderLeft:"2px solid var(--border-active)", padding:"10px 12px", lineHeight:1.55 }}>
            La troncal <strong>no tiene tope propio</strong> de llamadas: el límite es por DID.
            Con {f.cantidad_dids} DIDs a {f.max_channels_por_did}, el techo es{" "}
            <strong>{f.cantidad_dids * f.max_channels_por_did} simultáneas</strong>.
          </div>

          {err && <div style={{ color:"var(--danger)", fontSize:12 }}>{err}</div>}
          <div style={{ display:"flex", gap:9, justifyContent:"flex-end" }}>
            <button className="nv-btn nv-btn-ghost" onClick={onClose}>Cancelar</button>
            <button className="nv-btn nv-btn-primary" disabled={busy || !f.origin_ip}
              onClick={crear}>
              {busy ? "Creando…" : b ? `Crear con ${f.cantidad_dids} DIDs` : "Crear sin numeración"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


/* ── Edicion de una troncal existente ── */
function ModalEditar({ troncal, onClose, onSaved }) {
  const [f, setF] = useState({ nombre: troncal.nombre || "",
                               origin_ip: troncal.origin_ip || "",
                               origin_port: troncal.origin_port || 5060,
                               usa_tls_srtp: troncal.usa_tls_srtp === "yes" });
  const [busy, setBusy] = useState(false);
  const [err, setErr]   = useState(null);
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const cambiaConexion = f.origin_ip !== troncal.origin_ip ||
                         Number(f.origin_port) !== Number(troncal.origin_port);

  const guardar = async () => {
    setBusy(true); setErr(null);
    try {
      const r = await apiv1.put(`/troncales/${troncal.id}`, {
        nombre: f.nombre, origin_ip: f.origin_ip, origin_port: Number(f.origin_port),
        usa_tls_srtp: f.usa_tls_srtp });
      onSaved(r.data);
    } catch (e) {
      setErr(e.response?.data?.detail || "No se pudo guardar");
    } finally { setBusy(false); }
  };

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(4,8,16,.7)",
      display:"grid", placeItems:"center", zIndex:300, padding:16, overflowY:"auto" }}>
      <div onClick={e => e.stopPropagation()} className="nv-card"
        style={{ width:"min(560px,100%)", padding:0, overflow:"hidden" }}>
        <div style={{ padding:"14px 18px", borderBottom:"1px solid var(--border)" }}>
          <div style={{ fontSize:14, fontWeight:600 }}>Editar troncal</div>
          <div style={{ ...mono, fontSize:11.5, color:"var(--text-secondary)", marginTop:2 }}>
            {troncal.origin_ip}:{troncal.origin_port}
          </div>
        </div>
        <div style={{ padding:18, display:"flex", flexDirection:"column", gap:14 }}>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:14 }}>
            <label style={lbl}>Nombre de la troncal
              <input style={inp} value={f.nombre} placeholder="Central Guayaquil"
                onChange={e => set("nombre", e.target.value)}/>
            </label>
            <label style={lbl}>IP de origen
              <input style={{ ...inp, ...mono }} value={f.origin_ip}
                onChange={e => set("origin_ip", e.target.value.trim())}/>
            </label>
            <label style={lbl}>Puerto
              <input style={{ ...inp, ...mono }} type="number" value={f.origin_port}
                onChange={e => set("origin_port", e.target.value)}/>
            </label>
          </div>

          {/* El check vive acá, con la troncal, porque es un atributo de ESTA conexión
              y no del cliente: un cliente puede tener una troncal cifrada y otra no. */}
          <label style={{ display:"flex", gap:9, alignItems:"flex-start", cursor:"pointer",
            background:"var(--bg-raised)", border:"1px solid var(--border)",
            borderRadius:"var(--r-sm)", padding:"10px 12px" }}>
            <input type="checkbox" checked={f.usa_tls_srtp} style={{ marginTop:2 }}
              onChange={e => set("usa_tls_srtp", e.target.checked)}/>
            <span style={{ fontSize:12, lineHeight:1.5 }}>
              <strong>Usa TLS/SRTP</strong> — esta troncal llega cifrada, o sea que entra
              por el SBC y aparece en su listado de clientes.
              <span style={{ display:"block", color:"var(--text-secondary)", fontSize:11.5, marginTop:4 }}>
                Es una <strong>declaración, no una configuración</strong>: Kamailio escucha
                TLS en el 5061 para cualquiera que llegue, no discrimina por cliente. Marcar
                esto no cifra nada — para que la troncal use TLS hay que apuntarla a
                192.168.182.21:5061 del lado del equipo del cliente.
              </span>
            </span>
          </label>

          {cambiaConexion && (
            <div style={{ fontSize:11.5, color:"var(--text-secondary)", background:"var(--warning-bg)",
              borderLeft:"2px solid var(--warning)", padding:"10px 12px", lineHeight:1.55 }}>
              Cambiar la conexión <strong>reprovisiona la troncal en Asterisk</strong>: deja de
              confiar en {troncal.origin_ip} y pasa a confiar en {f.origin_ip || "(vacío)"}. Las
              llamadas en curso no se cortan, pero el equipo viejo deja de poder cursar.
            </div>
          )}

          <div style={{ fontSize:11.5, color:"var(--text-secondary)" }}>
            La numeración y los topes por DID no se tocan acá: siguen como están.
          </div>

          {err && <div style={{ color:"var(--danger)", fontSize:12 }}>{err}</div>}
          <div style={{ display:"flex", gap:9, justifyContent:"flex-end" }}>
            <button className="nv-btn nv-btn-ghost" onClick={onClose}>Cancelar</button>
            <button className="nv-btn nv-btn-primary" disabled={busy || !f.origin_ip}
              onClick={guardar}>{busy ? "Guardando…" : "Guardar"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}


/* ── Chip de alcanzabilidad ── */
// "En Asterisk" dice que la CONFIGURACION esta; esto dice si el equipo del cliente CONTESTA
// el OPTIONS del qualify. Son cosas distintas: una troncal puede estar perfecta y el equipo
// del cliente apagado.
function ChipContacto({ contacto }) {
  if (!contacto) {
    return <ChipMuted title="Asterisk no tiene contacto para esta troncal">Sin contacto</ChipMuted>;
  }
  const { estado, rtt_ms } = contacto;
  if (estado === "Avail") {
    return <ChipOk title="El equipo del cliente responde el qualify">
      Responde{rtt_ms != null ? ` · ${rtt_ms} ms` : ""}</ChipOk>;
  }
  if (estado === "Unavail") {
    return <Chip bg="var(--danger-bg)" bd="var(--danger)" fg="var(--danger)"
      title="Asterisk lo sondea y no contesta: revisá que el equipo esté encendido y que haya ruta">
      No responde</Chip>;
  }
  // NonQual: el contacto existe pero Asterisk no lo esta sondeando, asi que no se sabe.
  return <ChipMuted title={`Asterisk no está sondeando esta troncal (${estado}): no se puede saber si responde`}>
    Sin sondeo</ChipMuted>;
}


// Texto del resultado de la automatización de whitelist, para el mensaje del alta.
// Se dice SIEMPRE, tanto si salió bien como si no: el operador tiene que saber si le quedó
// una troncal con la IP sin autorizar.
function textoWhitelist(wl) {
  if (!wl) return "";
  if (wl.accion === "agregada")     return ` La IP se agregó a la whitelist del firewall.`;
  if (wl.accion === "ya_cubierta")  return ` La IP ya estaba cubierta por ${wl.cubierta_por} en la whitelist.`;
  return ` ⚠️ NO se pudo agregar la IP a la whitelist (${wl.motivo || "el firewall no respondió"}) — agregala a mano en Firewall.`;
}


/* ── Chip de whitelist del firewall ── */
// La IP de origen se agrega sola al crear la troncal. Este chip existe porque esa
// automatización puede fallar en silencio (el puente al host es un SSH): si no se muestra,
// nadie se entera hasta que fail2ban banea al cliente y las llamadas dejan de entrar.
function ChipWhitelist({ wl }) {
  if (!wl || !wl.disponible) {
    return <ChipMuted title="No se pudo leer la whitelist del firewall (el puente al host no respondió)">
      Whitelist: sin verificar</ChipMuted>;
  }
  if (wl.en_whitelist) {
    const porRed = wl.cubierta_por && wl.cubierta_por.includes("/");
    return <ChipOk title={porRed
      ? `Cubierta por la red ${wl.cubierta_por} (${wl.comentario || "sin comentario"})`
      : `Entrada ${wl.cubierta_por} — ${wl.comentario || "sin comentario"}`}>
      {porRed ? `En whitelist (${wl.cubierta_por})` : "En whitelist"}</ChipOk>;
  }
  return <Chip bg="var(--danger-bg)" bd="var(--danger)" fg="var(--danger)"
    title="La IP de origen NO está en la whitelist del firewall: fail2ban puede banear al equipo del cliente">
    Falta en whitelist</Chip>;
}


/* ── Panel de troncales del cliente ── */
// `permisosEditables` va aparte de `editable`: editar los permisos DE LA TRONCAL exige rol
// admin (igual que el PUT /v1/troncales/{id}/permisos), pero los de UN número suelto los puede
// escribir un `sac`. Separarlos es lo que evita ampliar o recortar permisos al haber movido la
// pantalla acá desde la pestaña Permisos.
export default function TroncalCliente({ cliente, editable = true, permisosEditables = false }) {
  const [troncales, setTron] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [err, setErr]     = useState(null);
  const [modal, setModal] = useState(false);
  const [abierta, setAbierta] = useState(null);
  const [msg, setMsg]     = useState(null);
  const [ocupada, setOcupada] = useState(null);   // id de la troncal en la que se está operando
  // `window.confirm` devuelve false sin abrir nada en este navegador: ver ConfirmDialog.js.
  const [confirmar, dialogoConfirm] = useConfirm();
  const [editando, setEditando] = useState(null);
  const [permisosDe, setPermisosDe] = useState(null);   // troncal con el panel de permisos abierto

  const cargar = useCallback(async () => {
    if (!cliente?.id) return;
    setErr(null);
    try {
      const r = await apiv1.get(`/troncales/cliente/${cliente.id}`);
      setTron(Array.isArray(r.data?.data) ? r.data.data : []);
    } catch (e) {
      setErr(e.response?.data?.detail || "No se pudieron cargar las troncales");
    } finally { setCargando(false); }
  }, [cliente?.id]);
  useEffect(() => { cargar(); }, [cargar]);

  // Reprovisionar: vuelve a escribir las filas PJSIP desde lo que dice el padrón. Hace falta
  // cuando la troncal quedó creada pero sin llegar a Asterisk (chip "No provisionada").
  const reprovisionar = async (t) => {
    setOcupada(t.id); setErr(null); setMsg(null);
    try {
      const r = await apiv1.post(`/troncales/${t.id}/reprovisionar`);
      setMsg(`Troncal «${t.nombre || t.id}» reprovisionada en Asterisk (endpoint ${r.data?.asterisk?.endpoint}).`
        + textoWhitelist(r.data?.whitelist));
      await cargar();
    } catch (e) {
      setErr(e.response?.data?.detail || "No se pudo reprovisionar");
    } finally { setOcupada(null); }
  };

  const borrar = async (t) => {
    const n = (t.dids || []).length;
    if (!(await confirmar(`Borrar la troncal «${t.nombre || t.id}» (${t.origin_ip})?\n\n` +
        `Sus ${n} DID(s) dejan de recibir llamadas y se libera la numeración.`))) return;
    setOcupada(t.id); setErr(null); setMsg(null);
    try {
      await apiv1.delete(`/troncales/${t.id}?confirmar=true`);
      setMsg(`Troncal «${t.nombre || t.id}» borrada.`);
      await cargar();
    } catch (e) {
      setErr(e.response?.data?.detail || "No se pudo borrar");
    } finally { setOcupada(null); }
  };

  // Suspender un DID le corta las SALIENTES y le deja las entrantes (lo lee el AGI de
  // ruteo por el ANI, en la llamada siguiente: no hay reload ni reprovisioning de por
  // medio). Hasta 2026-09-15 esta columna se mostraba pero no se podía tocar.
  const cambiarEstadoDid = async (t, d) => {
    const suspender = d.status !== "suspended";
    if (suspender && !window.confirm(
        `Suspender el DID ${d.did_number}?\n\n` +
        "Deja de poder hacer llamadas salientes. Las entrantes siguen entrando normalmente." +
        (d.is_principal ? "\n\n⚠️ Es el DID cabecera de la troncal." : ""))) return;
    setOcupada(`${t.id}:${d.did_number}`); setErr(null); setMsg(null);
    try {
      const r = await apiv1.put(`/troncales/${t.id}/dids/${d.did_number}/estado`,
                                { estado: suspender ? "suspended" : "active" });
      setMsg(`DID ${d.did_number} ${suspender ? "suspendido" : "reactivado"}. ` +
             (r.data?.advertencia || "Las entrantes no se ven afectadas."));
      await cargar();
    } catch (e) {
      setErr(e.response?.data?.detail || "No se pudo cambiar el estado del DID");
    } finally { setOcupada(null); }
  };

  const th = { textAlign:"left", fontSize:10, fontWeight:700, letterSpacing:".09em",
               textTransform:"uppercase", color:"var(--text-muted)", padding:"9px 14px",
               borderBottom:"1px solid var(--border)" };
  const td = { padding:"9px 14px", borderBottom:"1px solid var(--border)", fontSize:12.5 };

  return (
    <div>
      {dialogoConfirm}
      <div className="nv-card" style={{ marginBottom:12 }}>
        <div className="nv-card-header">
          <span className="nv-card-title">Troncales</span>
          <span style={{ ...mono, fontSize:11, color:"var(--text-muted)" }}>
            {troncales.length} {troncales.length === 1 ? "troncal" : "troncales"}
          </span>
        </div>
        <div style={{ fontSize:11.5, color:"var(--text-secondary)", lineHeight:1.55, marginBottom:12 }}>
          Este cliente se conecta por <strong>IP de origen</strong>, con un bloque de DIDs y un
          tope de llamadas por DID.{" "}
          {troncales.some(t => t.usa_tls_srtp === "yes")
            ? <>Las marcadas <strong>TLS/SRTP</strong> entran cifradas por el SBC; el resto
               apunta directo al Soft Switch.</>
            : <>Apunta directo al Soft Switch — el SBC no interviene.</>}
        </div>

        {msg && (
          <div style={{ marginBottom:12, padding:"10px 12px", background:"var(--success-bg)",
            border:"1px solid var(--success)", borderRadius:"var(--r-sm)", fontSize:12 }}>{msg}</div>
        )}
        {err && <div style={{ marginBottom:10, color:"var(--danger)", fontSize:12 }}>{err}</div>}

        {editable && (
          <button className="nv-btn nv-btn-primary" onClick={() => setModal(true)}>
            + Nueva troncal
          </button>
        )}
      </div>

      {cargando ? (
        <div className="nv-card" style={{ padding:28, textAlign:"center",
          color:"var(--text-secondary)", fontSize:12.5 }}>Cargando troncales…</div>
      ) : troncales.length === 0 ? (
        <div className="nv-card" style={{ padding:28, textAlign:"center",
          color:"var(--text-secondary)", fontSize:12.5 }}>
          Todavía no tiene troncales. Creá la primera con el botón de arriba: ahí se configura la
          IP de origen y se propone el bloque de DIDs.
        </div>
      ) : troncales.map(t => {
        const ast = t.asterisk || {};
        const dids = t.dids || [];
        const techo = dids.reduce((a, d) => a + (d.max_channels || 0), 0);
        const abierto = abierta === t.id;
        const permAbierto = permisosDe === t.id;
        return (
          <div key={t.id} className="nv-card" style={{ padding:0, marginBottom:12, overflow:"hidden" }}>
            <div style={{ padding:"14px 16px", display:"flex", gap:16, alignItems:"center",
              flexWrap:"wrap", borderBottom: (abierto || permAbierto) ? "1px solid var(--border)" : "none" }}>
              <div>
                <div style={{ fontWeight:600, fontSize:13.5 }}>{t.nombre || "(sin nombre)"}</div>
                <div style={{ ...mono, fontSize:11.5, color:"var(--text-secondary)", marginTop:2 }}>
                  {t.origin_ip}:{t.origin_port}
                </div>
              </div>
              <div style={{ display:"flex", gap:22 }}>
                <div><div style={{ ...mono, fontSize:17, fontWeight:600 }}>{dids.length}</div>
                  <div style={{ fontSize:9.5, fontWeight:700, letterSpacing:".1em",
                    textTransform:"uppercase", color:"var(--text-muted)" }}>DIDs</div></div>
                {/* En uso / techo. El techo es la SUMA de los topes por DID y es
                    informativo: el tope que se aplica es el de cada ANI por separado, no un
                    cap agregado por cliente. `null` = AMI no respondió, y se muestra "—"
                    en vez de un 0 que se leería como "no hay llamadas". */}
                <div><div style={{ ...mono, fontSize:17, fontWeight:600,
                    color: t.canales_en_uso > 0 ? "var(--success)" : "var(--text-primary)" }}>
                    {t.canales_en_uso == null ? "—" : t.canales_en_uso}
                    <span style={{ fontSize:12, color:"var(--text-muted)", fontWeight:400 }}>
                      {" / "}{t.techo_canales ?? techo}</span>
                  </div>
                  <div style={{ fontSize:9.5, fontWeight:700, letterSpacing:".1em",
                    textTransform:"uppercase", color:"var(--text-muted)" }}>Canales en uso</div></div>
              </div>
              <div style={{ marginLeft:"auto", display:"flex", gap:7, alignItems:"center", flexWrap:"wrap" }}>
                {dids.length === 0 && <ChipWarn>Sin numeración</ChipWarn>}
                {ast.provisionada
                  ? <ChipOk title={`Endpoint ${ast.endpoint} identificado por IP en Asterisk`}>Configurada</ChipOk>
                  : <ChipWarn title="Las filas PJSIP no están: la troncal no cursa">No provisionada</ChipWarn>}
                {ast.provisionada && <ChipContacto contacto={ast.contacto} />}
                <ChipWhitelist wl={t.whitelist} />
                {t.usa_tls_srtp === "yes" && (
                  <ChipBrand title="Troncal cifrada: el TLS/SRTP termina en el SBC, así que esta troncal sí pasa por el SBC y figura en su listado">
                    TLS/SRTP
                  </ChipBrand>
                )}
                {ast.tiene_credencial_indebida && (
                  <Chip bg="var(--danger-bg)" bd="var(--danger)" fg="var(--danger)"
                    title="Hay una credencial además del IP-trust: es una puerta trasera, hay que quitarla">
                    Credencial indebida
                  </Chip>
                )}
                <button className="nv-btn nv-btn-ghost" style={{ padding:"4px 10px", fontSize:11.5 }}
                  onClick={() => setAbierta(abierto ? null : t.id)}>
                  {abierto ? "▾" : "▸"} DIDs
                </button>
                {/* Los permisos de marcado se configuran acá, en la fila de la troncal: la
                    configuracion de un servicio va con su entidad. La pestaña Permisos de la
                    ficha quedó como resumen de solo lectura. */}
                <button className="nv-btn nv-btn-ghost" style={{ padding:"4px 10px", fontSize:11.5 }}
                  onClick={() => setPermisosDe(permAbierto ? null : t.id)}
                  title="Qué tipos de llamada puede hacer esta troncal — aplica a todos sus ANIs">
                  {permAbierto ? "▾" : "🔒"} Permisos
                </button>
                {editable && (
                  <>
                    <button className="nv-btn nv-btn-ghost" style={{ padding:"4px 10px", fontSize:11.5 }}
                      onClick={() => setEditando(t)} title="Cambiar nombre, IP de origen o puerto">
                      ✎ Editar
                    </button>
                    <button className="nv-btn nv-btn-ghost" style={{ padding:"4px 10px", fontSize:11.5 }}
                      disabled={ocupada === t.id} onClick={() => reprovisionar(t)}
                      title="Vuelve a escribir las filas PJSIP desde el padrón">
                      {ocupada === t.id ? "…" : "⟳ Reprovisionar"}
                    </button>
                    <button className="nv-btn nv-btn-danger" style={{ padding:"4px 10px", fontSize:11.5 }}
                      disabled={ocupada === t.id} onClick={() => borrar(t)}>
                      ✕ Borrar
                    </button>
                  </>
                )}
              </div>
            </div>

            {permAbierto && (
              <div style={{ borderBottom: abierto ? "1px solid var(--border)" : "none" }}>
                <PermisosDeUnaTroncal troncal={t} editable={editable}
                  editableDid={permisosEditables || editable}/>
              </div>
            )}

            {abierto && (
              <div style={{ overflowX:"auto" }}>
                {dids.length === 0 ? (
                  <div style={{ padding:22, textAlign:"center", color:"var(--text-secondary)", fontSize:12.5 }}>
                    Esta troncal no tiene DIDs asignados todavía.
                  </div>
                ) : (
                  <table style={{ width:"100%", borderCollapse:"collapse" }}>
                    <thead><tr>
                      <th style={th}>DID</th><th style={th}>En uso</th><th style={th}>Simultáneas</th>
                      <th style={th}>Rotativo</th><th style={th}>Sale como</th><th style={th}>Estado</th>
                    </tr></thead>
                    <tbody>
                      {dids.map(d => (
                        <tr key={d.did_number}>
                          <td style={{ ...td, ...mono, fontWeight:600 }}>
                            {d.did_number}{" "}
                            {d.is_principal ? <ChipBrand>Cabecera</ChipBrand> : null}
                          </td>
                          <td style={{ ...td, ...mono,
                            color: d.canales_en_uso > 0 ? "var(--success)" : "var(--text-muted)",
                            fontWeight: d.canales_en_uso > 0 ? 600 : 400 }}>
                            {d.canales_en_uso == null ? "—" : d.canales_en_uso}
                          </td>
                          <td style={{ ...td, ...mono }}>{d.max_channels}</td>
                          <td style={td}>{d.rotativo
                            ? <ChipOk>En rotativo</ChipOk>
                            : <span style={{ color:"var(--text-muted)" }}>Fuera</span>}</td>
                          <td style={td}>{d.clir
                            ? <ChipWarn title="CLIR: no presenta el número al llamar">Oculto</ChipWarn>
                            : <span style={{ color:"var(--text-secondary)" }}>Su número</span>}</td>
                          <td style={td}>
                            {(() => {
                              const susp = d.status === "suspended";
                              const chip = susp
                                ? <ChipMuted title="No puede hacer salientes; sigue recibiendo entrantes">Suspendido</ChipMuted>
                                : <ChipOk title="Puede hacer salientes">Activo</ChipOk>;
                              if (!editable) return chip;
                              const busy = ocupada === `${t.id}:${d.did_number}`;
                              return (
                                <span style={{ display:"inline-flex", alignItems:"center", gap:7 }}>
                                  {chip}
                                  <button className="nv-btn nv-btn-ghost" disabled={busy}
                                    style={{ padding:"2px 8px", fontSize:11 }}
                                    onClick={() => cambiarEstadoDid(t, d)}
                                    title={susp
                                      ? "Vuelve a poder hacer llamadas salientes"
                                      : "Le corta las salientes. Las entrantes siguen igual."}>
                                    {busy ? "…" : (susp ? "Reactivar" : "Suspender")}
                                  </button>
                                </span>
                              );
                            })()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        );
      })}

      {editando && (
        <ModalEditar troncal={editando} onClose={() => setEditando(null)}
          onSaved={(r) => {
            setEditando(null);
            setMsg((r.reprovisionada
              ? `Troncal actualizada y reprovisionada: ahora confía en ${r.origin_ip}:${r.origin_port}.`
              : `Troncal actualizada.`) + textoWhitelist(r.whitelist?.agregada));
            cargar();
          }}/>
      )}

      {modal && (
        <ModalNueva cliente={cliente} onClose={() => setModal(false)}
          onSaved={(r) => {
            setModal(false);
            setMsg((r.sin_numeracion
              ? `Troncal creada SIN numeración (${r.motivo_sin_numeracion || "no había bloque libre"}). Endpoint ${r.endpoint}.`
              : `Troncal creada con ${r.cantidad_dids} DIDs (${r.dids?.[0]} → ${r.dids?.[r.dids.length-1]}). Endpoint ${r.endpoint}.`)
              + textoWhitelist(r.whitelist));
            cargar();
          }}/>
      )}
    </div>
  );
}
